<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline secondary--text">{{ $t('program.list.title') }}</div>
      </div>
      <v-spacer></v-spacer>
      <ProgramAddDialog @created="$emit('created')"></ProgramAddDialog>
    </v-card-title>
    <v-card flat>
      <v-card-text v-if="programs" class="px-0">
        <v-data-table :headers="table_headers" :items="programs.data" :loading="loading" :pagination.sync="pagination"
          :total-items="total" :rows-per-page-items="rowsPerPageItems">
          <template v-slot:items="props">
            <tr class="cursor-pointer" @click="goToProgramPage(props.item.id)">
              <td class="text-xs-left subheading">{{ props.item.id }}</td>
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-left">
                <v-chip
                  :color="props.item.status == DEFINES.PROGRAM_STATUS.INACTIVE ? 'error' :'success'"
                  class="secondary secondary--text font-weight-medium"
                  small
                  outline>
                  {{ DEFINES.PROGRAM_STATUS_STR[props.item.status] }}
                </v-chip>
              </td>
              <td class="text-xs-left">{{ fmtTime(props.item.starts_at) }}</td>
              <td class="text-xs-left">{{ fmtTime(props.item.ends_at) }}</td>

              <td class="text-xs-center">
                <template>
                  <router-link :to="{ name: 'programs.update', params: { program_id: props.item.id } }">
                   {{ $t("program.list.action.edit") }}
                  </router-link>
                </template>
              </td>
            </tr>
          </template>
        </v-data-table>

      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import { utcToTz } from "@/helper";
import ProgramAddDialog from "./ProgramAddDialog";
import i18n from "@/i18n";
import {mapGetters} from 'vuex'
import DEFINES from '@/defines'

export default {
  name: "ProgramList",
  props: {
    programs: {
      type: Object,
      default: null
    }
  },
  components: {
    ProgramAddDialog
  },
  data() {
    return {
      table_headers: [
        {
          text: i18n.t('Program.list.table.head.s.n'),
          align: "left",
          sortable: true,
          value: "id"
        },
        {
          text: i18n.t('Program.list.table.head.name'),
          align: "left",
          sortable: true,
          value: "name"
        },
        {
          text: i18n.t('Program.list.table.head.status'),
          align: "left",
          sortable: true,
          value: "status"
        },
        {
          text: i18n.t('Program.list.table.head.start_date'),
          align: "left",
          sortable: true,
          value: "start_date"
        },
        {
          text: i18n.t('Program.list.table.head.end_date'),
          align: "left",
          sortable: true,
          value: "end_date"
        },
        {
          text: i18n.t('Program.list.table.head.action'),
          align: "center",
          sortable: false,
          value: "action"
        }
      ],
      rowsPerPageItems: [5, 10, 25, 50, 100],
      pagination: {
        sortBy: "start_date",
        descending: true,
        page: 1,
        rowsPerPage: 10,
      },
    };
  },
  computed: {
    // timezone
    ...mapGetters('company', {
      timezone: 'getSelectedCompanyTimezone',
    }),
  },
  methods: {
    // convert utc to comapny timezone
    fmtTime(input) {
      return utcToTz(input, this.timezone, 'MMMM Do YYYY, h:mm a');
    },
    goToProgramPage(program_id){
      this.$router.push({
          name: 'programs.update',
          params: {
            program_id: program_id,
          },
      })
    }
  }
};
</script>
